import { api } from "@/lib/api";

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/uploads", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data; // { url, content_type, size }
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const absoluteUrl = (path) => {
  if (!path) return path;
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  return `${BACKEND_URL}${path}`;
};
